import { render, staticRenderFns } from "./add-human.vue?vue&type=template&id=3f455faa&scoped=true&lang=pug"
import script from "./add-human.js?vue&type=script&lang=js&external"
export * from "./add-human.js?vue&type=script&lang=js&external"
import style0 from "./add-human.vue?vue&type=style&index=0&id=3f455faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f455faa",
  null
  
)

export default component.exports